import {
    Component,
    OnInit,
    Inject,
    ElementRef,
    ViewChild,
} from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { HttpService } from "app/services/http.service";
import { environment } from "environments/environment";

@Component({
    selector: "app-preview-purchase-order-dialog",
    templateUrl: "./preview-purchase-order-dialog.component.html",
    styleUrls: ["./preview-purchase-order-dialog.component.scss"],
})
export class PreviewPurchaseOrderDialogComponent implements OnInit {
    @ViewChild("contentIframe") contentIframe?: ElementRef;

    content: any;
    data: any;
    loading = false;

    env = environment;

    constructor(
        protected httpService: HttpService,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        public matDialogRef: MatDialogRef<PreviewPurchaseOrderDialogComponent>
    ) {
        this.data = _data;
    }

    isIFrame = (input: HTMLElement | null): input is HTMLIFrameElement =>
        input !== null && input.tagName === "IFRAME";

    print() {
        let frame = document.getElementById("purchase-order-frame");
        if (this.isIFrame(frame) && frame.contentWindow) {
            frame.contentWindow.print();
        }
    }

    openPDF() {
        if (this.data?.tokenLink) {
            const timestamp = new Date().getTime();
            const url = this.env.baseUrlHotsite + '/pedido-compra/' + this.data.tokenLink + '.pdf?v=' + timestamp;
            window.open(url, '_blank');
        }
    }

    ngOnInit() {
        this.loading = true;
        this.httpService
            .post("/v1/clients/preview-purchase-order", { id: this.data.id })
            .subscribe(
                (data) => {
                    this.content = data?.data?.content;
                    this.writeContent(this.content || this.errorContent());
                    this.loading = false;
                },
                () => {
                    // sem isto o spinner ficava girando para sempre
                    this.writeContent(this.errorContent());
                    this.loading = false;
                }
            );
    }

    private writeContent(html: string) {
        const doc = this.contentIframe?.nativeElement?.contentWindow?.document;
        if (!doc) return;
        doc.open();
        doc.write(html);
        doc.close();
    }

    private errorContent(): string {
        return '<p style="font-family: sans-serif; color: #4A5568; padding: 16px;">'
            + 'Não foi possível carregar a visualização. Feche e tente novamente.</p>';
    }
}
